import React from 'react';
import { Space, Switch, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (checked: boolean) => {
    const newLang = checked ? 'fa' : 'en';
    i18n.changeLanguage(newLang);
    // Store language preference
    localStorage.setItem('preferredLanguage', newLang);
    // Set HTML dir attribute for RTL support
    document.documentElement.dir = newLang === 'fa' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  return (
    <Space>
      <GlobalOutlined />
      <Text>English</Text>
      <Switch
        checked={i18n.language === 'fa'}
        onChange={handleLanguageChange}
        aria-label="Switch language"
      />
      <Text>فارسی</Text>
    </Space>
  );
};

export default LanguageSwitcher;
